import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import {
  defaultNamespace,
  fallbackLanguage,
  initialNamespaces,
  languageStorageKey,
  supportedLanguages,
} from "./constants";
import { normalizeSupportedLanguage } from "./language-preference";

let initialization: Promise<typeof i18n>;

if (!i18n.isInitialized) {
  initialization = i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      supportedLngs: supportedLanguages,
      fallbackLng: fallbackLanguage,
      ns: initialNamespaces,
      defaultNS: defaultNamespace,
      fallbackNS: defaultNamespace,
      load: "currentOnly",
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ["localStorage", "navigator"],
        lookupLocalStorage: languageStorageKey,
        caches: [],
        convertDetectedLanguage: (lng) =>
          normalizeSupportedLanguage(lng) ?? fallbackLanguage,
      },
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
      },
      react: {
        useSuspense: true,
      },
      returnEmptyString: false,
    })
    .then(() => i18n)
    .catch(() => {
      return i18n;
    });
} else {
  initialization = Promise.resolve(i18n);
}

export const i18nReady = initialization;
export default i18n;
